<template>
  <div>
    <logged-in-header />
    <opportunities-panel />
    <empower-footer />
    <whats-app />
  </div>
</template>

<script>
import loggedInHeader from "../../components/commom/LoggedInHeader";
import empowerFooter from "../../components/commom/EmpowerFooter";
import opportunitiesPanel from "../../components/opportunities/OpportunitiesPanel";
import WhatsApp from "../../components/commom/WhatsApp";

export default {
  components: {
    loggedInHeader,
    empowerFooter,
    opportunitiesPanel,
    WhatsApp
  }
};
</script>
